import { USER_KEY } from "./constants";
import Storage from "./Storage";

class UserStorage extends Storage {

	constructor() {
		super(USER_KEY);
		this._username = this._storage;
	}

	get username() {
		return this._username;
	}

	set username(u) {
		this._username = u;
		this._storage = this._username;
	}
}

export default UserStorage;
export const user = new UserStorage();
